import { useRef, useState } from "react";
import { CloudUpload } from "lucide-react";
import { cn } from "@/lib/utils";

export default function UploadDropzone({ onFiles }) {
  const inputRef = useRef(null);
  const [hover, setHover] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setHover(false);
    if (e.dataTransfer?.files?.length) {
      onFiles?.(e.dataTransfer.files);
    }
  };

  return (
    <div
      data-testid="upload-dropzone"
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setHover(true);
      }}
      onDragLeave={() => setHover(false)}
      onDrop={handleDrop}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") inputRef.current?.click();
      }}
      className={cn(
        "flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-[28px] border-2 border-dashed px-6 py-10 text-center transition-colors",
        hover
          ? "border-violet-400 bg-violet-50/50"
          : "border-black/[0.10] bg-white/60 hover:bg-white",
      )}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-zinc-100 text-zinc-700">
        <CloudUpload className="h-5 w-5" strokeWidth={2.2} />
      </div>
      <div className="text-[14px] font-bold text-zinc-900">
        Drag & drop files here, or click to browse
      </div>
      <div className="text-[12px] text-zinc-500">
        PDF, DOCX, XLSX, PNG, JPG · max 25MB
      </div>
      <input
        ref={inputRef}
        type="file"
        multiple
        className="hidden"
        data-testid="upload-input"
        onChange={(e) => onFiles?.(e.target.files)}
      />
    </div>
  );
}
